import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'

import { useUnAuthWarningModal } from '@/buyer-portal/components/features/UnAuthWarningModal'

import { useMergedMedia } from '../shared/useMergedMedia'
import { ListingMedia } from './ListingMedia'

const MediaSectionContainer = styled.div`
  display: flex;
  grid-area: images;
`

const Details = styled.div`
  width: 100%;
`

export const MediaSection = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const { formatMessage } = useIntl()
  const isLoggedIn = !!useDecodedAccessToken()?.personId
  const { openUnAuthModal } = useUnAuthWarningModal()
  const { media, description } = listing.lot
  const title = listing.lot.title || formatMessage({ id: 'Common.unknown' })
  const allMedia = useMergedMedia(media, description)

  return (
    <MediaSectionContainer>
      <Details>
        <ListingMedia
          auctionTitle={title}
          media={allMedia}
          isLoggedIn={isLoggedIn}
          onFireUnAuthCTA={openUnAuthModal}
        />
      </Details>
    </MediaSectionContainer>
  )
}
